<template>
  <div v-if="isAuthenticated" class="balance-display">
    <div 
      class="balance-item user-balance" 
      :title="`Persönliches Guthaben: ${userBalance}`"
    >
      <font-awesome-icon icon="user" class="balance-icon" />
      <span class="balance-amount">{{ userBalance }}</span>
    </div>
    <div 
      v-if="showTeamBalance" 
      class="balance-item team-balance"
      :title="`Guthaben von Bereich ${selectedTeam?.name || 'Unbekannt'}: ${teamBalance}`"
    >
      <font-awesome-icon icon="users" class="balance-icon" />
      <span class="balance-amount">{{ teamBalance }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useTeamsStore } from '@/stores/teams'
import { storeToRefs } from 'pinia'

const route = useRoute()
const authStore = useAuthStore()
const teamsStore = useTeamsStore()
const { user, isAuthenticated } = storeToRefs(authStore)
const { selectedTeam } = storeToRefs(teamsStore)

const userBalance = computed(() => {
  return user.value?.account?.amount || 0
})

const teamBalance = computed(() => {
  return selectedTeam.value?.account?.amount || 0
})

const hasTeamBalance = computed(() => {
  return selectedTeam.value && selectedTeam.value.account
})

const showTeamBalance = computed(() => {
  // Show team balance only if we're on a page with teamId parameter
  return hasTeamBalance.value && route.path?.includes('teams') && (route.params.teamId || route.params.id)
})
</script>

<style scoped>
.balance-display {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.balance-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
  min-width: 4rem;
  justify-content: center;
}

.balance-item:hover {
  transform: translateY(-1px);
}

.balance-icon {
  color: var(--quitly-warning);
  font-size: 0.875rem;
}


.team-balance .balance-icon {
  color: var(--quitly-primary);
}
.user-balance {
  color: var(--quitly-warning);
}

.team-balance {
  color: var(--quitly-primary);
}

@media (max-width: 992px) {
    .team-balance .balance-item,
    .team-balance .balance-icon,
    .team-balance .balance-amount {
    color: black !important;
  }
}

.balance-amount {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  text-align: center;
}



@media (max-width: 768px) {
  .balance-display {
    gap: 0.2rem;
  }
  
  .balance-item {
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
    min-width: 3.5rem;
  }
  
  .balance-amount {
    font-size: 0.75rem;
  }
}

@media (max-width: 576px) {
  .balance-display {
    gap: 0.25rem;
  }
  
  .balance-item {
    min-width: 3rem;
  }
}
</style>
